
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"24.733","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.334 2.055C9.437 4.384 12.775 9.108 14 11.643c1.226-2.535 4.563-7.259 7.666-9.588 2.239-1.681 5.867-2.982 5.867 1.157 0 .827-.474 6.944-.752 7.937-.966 3.453-4.487 4.333-7.618 3.8 5.474.932 6.867 4.018 3.859 7.104-5.712 5.861-8.209-1.471-8.849-3.349-.117-.344-.172-.505-.173-.368-.001-.137-.056.024-.173.368-.64 1.879-3.138 9.21-8.849 3.349-3.007-3.086-1.615-6.172 3.859-7.104-3.132.533-6.652-.348-7.618-3.8C.94 10.155.467 4.038.467 3.212c0-4.139 3.628-2.838 5.867-1.157z"}})])
          )
        }
      }
    